<template>
  <div id="home">
    <el-container>

      <el-header style="display:flex;background-color: #f2f5f6;box-shadow:0px 10px 10px 0px rgba(111,84,153,0.5)">

        <div style="width:14%;height:60px;"></div>

        <div style="width:76%;height:60px;display: flex;">
          <div id="header-company-avatar">
            <el-avatar shape="square" size="large" src="../../logo.png"></el-avatar>
          </div>

          <p style="display:inline;float: left;width:10px"></p>

          <div id="header-company">
            <el-button type="text" style="color:#6f5499" @click="showHello">
              <span style="font-size:18px">{{ companyName }}</span>
            </el-button>
          </div>
        </div>

        <div style="width:10%;height:60px;display: flex;">
          <div id="header-avatar">
            <el-avatar :src="avatar"></el-avatar>
          </div>

          <div id="header-username">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="personalCenter"
                  v-loading.fullscreen.lock="fullscreenLoading">个人中心</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出系统</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <div style="width: 100%;height: 10px;"></div>

      <el-container style="width:100%;height:900px;">
        <el-aside style="width:210px;background-color: #f2f5f6;box-shadow:10px 0px 10px 0px rgba(111,84,153,0.5)">
          <div style="width: 100%;height: 10px;"></div>

          <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" fill="orange" @input="radioInput">
            <el-radio-button :label="true">收起</el-radio-button>
            <el-radio-button :label="false">展开</el-radio-button>
          </el-radio-group>

          <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            @select="handleSelect" :collapse="isCollapse" :unique-opened="true">
            <!-- background-color="#f2f5f6" text-color="orange" active-text-color="orangered"  -->

            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-monitor"></i>
                <span slot="title" style="color:#6f5499">看板管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/cncKanban">CNC看板</el-menu-item>
                <el-menu-item index="/productionKanban">生产看板</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span slot="title" style="color:#6f5499">订单管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/moldOrder">模具订单</el-menu-item>
                <el-menu-item index="/moldBOM">模具BOM</el-menu-item>
                <el-menu-item index="/process">制定工艺</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span slot="title">设备维保</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="2-1" style="color:orange">设备管理</el-menu-item>
                <el-menu-item index="2-2" style="color:orange">保养计划</el-menu-item>
                <el-menu-item index="2-3">保养记录</el-menu-item>
              </el-menu-item-group>
            </el-submenu> -->

            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span slot="title" style="color:#6f5499">生产管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/productionSite">工艺流程</el-menu-item>
                <el-menu-item index="/assembly">装配</el-menu-item>
                <el-menu-item index="/polish">抛光</el-menu-item>
                <el-menu-item index="/moldTest">试模</el-menu-item>
                <el-menu-item index="/moldRepair">维修</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-rank"></i>
                <span slot="title" style="color:#6f5499">模具管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="/warehouse">仓储管理</el-menu-item>
                <el-menu-item index="4-2">模具保养</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span slot="title" style="color:#6f5499">工厂管理</span>
              </template>

              <el-menu-item-group>
                <!--<span slot="title">分组一</span>-->
                <el-menu-item index="/companyInfo">公司信息</el-menu-item>
                <el-menu-item index="/workSchedule">班次时间</el-menu-item>
                <!-- <el-menu-item index="1-3" style="color:orange">开机工人</el-menu-item> -->
                <el-menu-item index="/department">部门管理</el-menu-item>
                <el-menu-item index="/employee">员工管理</el-menu-item>
                <el-menu-item index="/role">角色&权限</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-reading"></i>
                <span slot="title" style="color:#6f5499">基础资料</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/bomBaseInfo">BOM资料</el-menu-item>
                <el-menu-item index="/customerBase">客户资料</el-menu-item>
                <el-menu-item index="/cutterBase">刀具资料</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-house"></i>
                <span slot="title" style="color:#6f5499">设备管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/equipmentManage">CNC设备</el-menu-item>
                <el-menu-item index="/operationLog">CNC操录</el-menu-item>

                
              </el-menu-item-group>
            </el-submenu>

             <el-submenu index="8">
              <template slot="title">
                <i class="el-icon-s-grid"></i>
                <span slot="title" style="color:#6f5499">工具管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/smartCabinet">智能柜</el-menu-item>
                <el-menu-item index="/accessLog">存取记录</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!--<el-submenu index="10">
              <template slot="title">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">报表管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="10-1">生产报表</el-menu-item>
                <el-menu-item index="10-2">订单进度表</el-menu-item>
                <el-menu-item index="10-2">模具成本统计表</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="11">
              <template slot="title">
                <i class="el-icon-bell"></i>
                <span slot="title">异常报警</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="11-1">异常停机/离岗</el-menu-item>
                <el-menu-item index="11-2">生产超时</el-menu-item>
              </el-menu-item-group>
            </el-submenu>  -->

            <!-- <el-submenu index="12">
              <template slot="title">
                <i class="el-icon-lock"></i>
                <span slot="title">权限管理</span>
              </template>

              <el-menu-item-group>
                <el-menu-item index="12-1" style="color:orange">部门管理</el-menu-item>
                <el-menu-item index="12-2" style="color:orange">员工管理</el-menu-item>
                <el-menu-item index="12-3" style="color:orange">角色&权限</el-menu-item>
              </el-menu-item-group>
            </el-submenu> -->

          </el-menu>
        </el-aside>

        <el-container style="height:900px;">
          <el-main>
            <!-- <Hello v-if="false" ref="hello"></Hello> -->

            <!-- <ProductionKanban v-if="isShowPage == '1-2'"></ProductionKanban> -->

            <!-- <MoldOrder v-if="isShowPage == '2-1'"></MoldOrder>
            <MoldBOM v-if="isShowPage == '2-2'"></MoldBOM>
            <Process v-show="isShowPage == '2-3'"></Process> -->

            <EquipmentManage v-if="isShowPage == '22-1'"></EquipmentManage>
            <MaintainPlan v-if="isShowPage == '22-2'"></MaintainPlan>

            <!-- <ProductionSite v-show="isShowPage == '3-1'"></ProductionSite>
            <Assembly v-if="isShowPage == '3-2'"></Assembly>
            <Polish v-if="isShowPage == '3-3'"></Polish>
            <MoldTest v-if="isShowPage == '3-4'"></MoldTest>
            <MoldRepair v-if="isShowPage == '3-5'"></MoldRepair> -->

            <!-- <Warehouse v-show="isShowPage == '/warehouse'"></Warehouse> -->

            <!-- <CompanyInfo v-if="isShowPage == '5-1'"></CompanyInfo>
            <WorkSchedule v-if="isShowPage == '5-2'"></WorkSchedule>
            <Department v-if="isShowPage == '5-3'"></Department>
            <Employee v-if="isShowPage == '5-4'"></Employee>
            <Role v-if="isShowPage == '5-5'"></Role> -->

            <!-- <BOMBaseInfo v-if="isShowPage == '6-1'"></BOMBaseInfo> -->
            <keep-alive>
              <router-view></router-view>
            </keep-alive>

          </el-main>

          <!-- <el-footer>
            <p style="color: #6f5499;">©️中山市节之星科技有限公司 <a href="https://beian.miit.gov.cn">粤ICP备2022114400号-2</a></p>
          </el-footer> -->
        </el-container>
      </el-container>

      <div style="width: 100%;height: 10px;"></div>

      <el-footer style="background-color: #f2f5f6;box-shadow:0px -10px 10px 0px rgba(111,84,153,0.5)">
        <p style="color: #6f5499;"><a href="https://beian.miit.gov.cn">粤ICP备2022114400号-2</a></p>
      </el-footer>

    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
//import World from "@/components/World.vue";
// import Hello from "@/components/Hello.vue";

// import ProductionKanban from "@/components/ProductionKanban.vue";

import EquipmentManage from "@/components/EquipmentManage.vue";
import MaintainPlan from "@/components/MaintainPlan.vue";

// import MoldOrder from "@/components/MoldOrder.vue";
// import MoldBOM from "@/components/MoldBOM.vue";
// import Process from "@/components/Process.vue";

// import ProductionSite from "@/components/ProductionSite.vue";
// import Assembly from "@/components/Assembly.vue";
// import Polish from "@/components/Polish.vue";
// import MoldTest from "@/components/MoldTest.vue";
// import MoldRepair from "@/components/MoldRepair.vue";

// import Warehouse from "@/components/Warehouse.vue";

// import CompanyInfo from "@/components/CompanyInfo.vue";
// import WorkSchedule from "@/components/WorkSchedule.vue";
// import Department from "@/components/Department.vue";
// import Employee from "@/components/Employee.vue";
// import Role from "@/components/Role.vue";

// import BOMBaseInfo from "@/components/BOMBaseInfo.vue";

export default {
  data() {
    return {
      defaultPath: this.getDefaultPath(),
      isCollapse: false,
      isShowHello: true,
      isShowPage: '',
      token: this.getToken(),
      userId: this.getUserId(),
      username: 'wx_ijbvzt',
      avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      companyId: this.getCompanyId(),
      companyName: '中国模具',
      fullscreenLoading: false
    };
  },
  components: {
    // Hello,
    // ProductionKanban,

    EquipmentManage, MaintainPlan,
    // MoldOrder, MoldBOM, Process,
    // ProductionSite, Assembly, Polish, MoldTest, MoldRepair,
    // Warehouse,
    // CompanyInfo, WorkSchedule,Department, Employee, Role,
    // BOMBaseInfo
  },
  methods: {
    showHello() {
      this.isShowPage = '';
      //this.isShowHello = true;

      this.setDefaultPath('/hello')
      this.$router.push({ path: '/hello' })
      // this.personalCenter(0)
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      // console.log(key);
      if (key.length > 3) {
        this.setDefaultPath(key)
        this.defaultPath = key

        this.$router.push({ path: key })/*.catch(err => {err})*/;
      }

      this.isShowPage = key;
      this.isShowHello = false;
      // console.log(keyPath);
    },
    handleCommand(command) {
      if (command == "logout") {
        this.logout()
      } else if (command == "personalCenter") {
        this.personalCenter(1)
      }
    },
    getCompanyInfo() {
      //alert("getCompanyInfo")
    },
    personalCenter(val) {
      this.isShowPage = false;

      this.setPersonalCenter(val)
      this.isShowHello = false;
      // console.log("start")
      this.fullscreenLoading = true;
      
      setTimeout(() => {
        this.isShowHello = true;
        this.fullscreenLoading = false;
      }, 900);

    },
    logout() {
      this.$axios({
        method: "POST",
        url: "/shiro/sys/logout",
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        if (result.status === 200) {
          const data = result.data;
          if (data.status === 200) {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
              duration: "1600"
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error",
              duration: "3000"
            });
          }
          this.setToken("");
          this.$router.push({ path: "/Login" });
        } else {
          this.$message({
            showClose: true,
            message: "操作失败，请联系管理员",
            type: "error",
            duration: "3000"
          });
        }
      });
    },
    radioInput(val) {
      //console.log(val)
    },
    getUser() {
      // console.log('getUser')
      // console.log(this.token)

      this.$axios({
        method: "get",
        url: "/shiro/user/get?userId=" + this.userId,
        data: {},
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data;

        if (data.status === 400) {
          this.$message(data.msg)
          this.$router.push({ path: "/Login" });
        }

        this.username = data.data.username
        this.avatar = data.data.avatar
      })
    }
  },
  mounted() {
    console.log('Home.vue-->mounted()')
    // console.log(this.defaultPath)
    this.setCurrentSystem(0)

    this.$router.push({ path: this.defaultPath }).catch(err => { err })

    this.setPersonalCenter(0)
    //alert(this.$route.query.userId)
    this.getUser()

    this.$axios({
      method: "post",
      url: "/shiro/company/get",
      data: {
        id: this.companyId
      }, headers: {
        token: this.token
      }
    }).then(result => {
      this.companyName = result.data.data.companyName
      // this.companyName =this.companyName.length<=8?this.companyName:this.companyName.substring(0,7)+'...'
    })

  },
  updated() {
    // console.log('updated')
  }
}
</script>

<style lang="stylus"></style>

<style>
body{
  font-family: 黑体;
  
}

#header-company-avatar {
  padding: 10px 0;
}

#header-company {
  padding: 10px 0;
}

#header-username {
  padding: 20px 0px 20px 10px;
}

#header-avatar {
  padding: 10px 0;
}

.el-dropdown-link {
  cursor: pointer;
  color: #6f5499;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

#hello-hello {
  height: 50px;
  line-height: 50px;
  color: orange;
  background-color: #f2f5f6;
  /* box-shadow: 0 0 6px rgba(0, 0, 0, .12); */
  border-radius: 5px;
  border: 1px solid #6f5499;
  margin: 0 0 20px 0;
}

.el-menu-item {
  color: orange;
}

.el-menu-item.is-active {
  color: white;
  background-color: orange;
}

.el-table{
  color: black;
}</style>